import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import { isIframed } from 'utils/bolt/client';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {	
	componentDidMount() {
		super.componentDidMount();
		const isIframe = isIframed();
		if (isIframe) {
			window.addEventListener('load', () => {
				window.parent.postMessage({
					type: 'didomi',
					script: `window.gdprAppliesGlobally=true;(function(){function a(e){if(!window.frames[e]){if(document.body&&document.body.firstChild){var t=document.body;var n=document.createElement("iframe");n.style.display="none";n.name=e;n.title=e;t.insertBefore(n,t.firstChild)}
						else{setTimeout(function(){a(e)},5)}}}function e(n,r,o,c,s){function e(e,t,n,a){if(typeof n!=="function"){return}if(!window[r]){window[r]=[]}var i=false;if(s){i=s(e,t,n)}if(!i){window[r].push({command:e,parameter:t,callback:n,version:a})}}e.stub=true;function t(a){if(!window[n]||window[n].stub!==true){return}if(!a.data){return}
						var i=typeof a.data==="string";var e;try{e=i?JSON.parse(a.data):a.data}catch(t){return}if(e[o]){var r=e[o];window[n](r.command,r.parameter,function(e,t){var n={};n[c]={returnValue:e,success:t,callId:r.callId};a.source.postMessage(i?JSON.stringify(n):n,"*")},r.version)}}
						if(typeof window[n]!=="function"){window[n]=e;if(window.addEventListener){window.addEventListener("message",t,false)}else{window.attachEvent("onmessage",t)}}}e("__tcfapi","__tcfapiBuffer","__tcfapiCall","__tcfapiReturn");a("__tcfapiLocator");(function(e){
							var t=document.createElement("script");t.id="spcloader";t.type="text/javascript";t.async=true;t.src="https://sdk.privacy-center.org/"+e+"/loader.js?target="+document.location.hostname;t.charset="utf-8";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n)})("7e0adb7d-f5cf-4762-820f-1b0138963fda")})();`
				}, '*');
				const el = document.querySelector('#didomi-host');
				if (el) {
					el.style.display = 'none';
				}
			}, false);

			window.addEventListener('message', (ev) => {
				const data = ev?.data;
				let cookie = null;
				const now = new Date();
				const inOneYear = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
				setTimeout(() => {
					if (data.didomiConsent) {
						cookie = data.didomiConsent;
						document.cookie = `${cookie};expires=${new Date(inOneYear).toUTCString()};path=/;SameSite=None;Secure`;
						localStorage.setItem('euconsent-v2', data.didomiConsent);
					}
					if (data.didomiToken) {
						cookie = data.didomiToken;
						document.cookie = `${cookie};expires=${new Date(inOneYear).toUTCString()};path=/;SameSite=None;Secure`;
						localStorage.setItem('didomi_token', data.didomiToken);
					}
				});
			});
		}
	}
}